import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks";

import {
  drawerWidth,
  images,
  GeneralAdminSideDrawerListItems,
  GeneralAdminRoutes,
  routes,
} from "../constants";
import UserProfileImage from "../GeneralAdmin/modules/GAUserProfile/components/UserProfileImage/UserProfileImage";

const GeneralAdminSidebar = () => {
  const navigate = useNavigate();
  const { onLogout, currentUser } = useAuth();

  const [sideDrawerItems, setSideDrawerItems] = useState([
    ...GeneralAdminSideDrawerListItems,
  ]);
  const [openSections, setOpenSections] = useState({});

  // Auto-open any collapsible parent whose child route is currently active.
  useEffect(() => {
    const newOpenSections = {};
    GeneralAdminSideDrawerListItems.forEach((item) => {
      if (item.collapsible && item.children) {
        const hasActiveChild = item.children.some((child) =>
          window.location.pathname.includes(child.path)
        );
        if (hasActiveChild) {
          newOpenSections[item.title] = true;
        }
      }
    });
    setOpenSections((prev) => ({ ...prev, ...newOpenSections }));
  }, [window.location.pathname]);

  const handleToggleSection = (title) => {
    setOpenSections((prev) => ({ ...prev, [title]: !prev[title] }));
  };

  const isChildActive = (path) =>
    !!path && window.location.pathname.includes(path);

  useEffect(() => {
    let temp = [...sideDrawerItems];
    let paths = window.location.pathname.split("/");
    let newPathname = "/";
    newPathname += paths[1];

    temp.forEach((item) => {
      let index = temp.indexOf(item);
      item.selected = false;
      if (item.path == window.location.pathname) {
        temp[index].selected = true;
      }

      if (window.location.pathname.includes(item.path)) {
        temp[index].selected = true;
      }

      if (item.path == newPathname) {
        temp[index].selected = true;
      }
    });
    setSideDrawerItems(temp);
  }, [window.location.pathname]);

  useEffect(() => {
    if (currentUser && currentUser?.type !== "general") {
      navigate(routes.dashboard);
    }
  }, [currentUser]);

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          background: "#00A7CD",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Toolbar>
        <img
          src={images.QuickTalesIcon}
          alt="quick tales icon"
          style={{ height: 30, width: 118 }}
        />
      </Toolbar>
      {/* <img
        src={images.LASHistoricParkIcon}
        alt="quick tales icon"
        style={{ height: 80, width: drawerWidth - 1 }}
      /> */}
      <List style={{ height: "100%" }}>
        {sideDrawerItems.map((item, index) => {
          if (item.collapsible && item.children) {
            const isOpen = openSections[item.title] || false;
            return (
              <React.Fragment key={index}>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => handleToggleSection(item.title)}
                    style={{ padding: 0, margin: 0 }}
                  >
                    <ListItemText style={listItemStyle}>
                      <span style={listItemTextStyles}>
                        {item.title}{" "}
                        <span>{isOpen ? "▾" : "▸"}</span>
                      </span>
                    </ListItemText>
                  </ListItemButton>
                </ListItem>
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.children.map((child) => {
                      const active = isChildActive(child.path);
                      return (
                        <ListItem key={child.title} disablePadding>
                          <ListItemButton
                            onClick={() => navigate(child.path)}
                            style={{ padding: 0, margin: 0 }}
                          >
                            <ListItemText
                              style={
                                active ? listItemSelectedStyle : listItemStyle
                              }
                            >
                              <span
                                style={{
                                  ...listItemTextStyles,
                                  paddingLeft: 16,
                                }}
                              >
                                {child.title}
                              </span>
                            </ListItemText>
                          </ListItemButton>
                        </ListItem>
                      );
                    })}
                  </List>
                </Collapse>
              </React.Fragment>
            );
          }
          return (
            <ListItem key={index} disablePadding>
              <ListItemButton
                onClick={
                  item.title === "Logout"
                  ? () => onLogout()
                  : () => {
                      let temp = [...sideDrawerItems];
                      temp.forEach((item) => {
                        item.selected = false;
                      });
                      let index = temp.indexOf(item);
                      temp[index].selected = true;
                      setSideDrawerItems(temp);
                      navigate(item.path);
                    }
              }
              style={{
                padding: 0,
                margin: 0,
              }}
            >
              <ListItemText
                style={item.selected ? listItemSelectedStyle : listItemStyle}
                //   primary={item.title}
              >
                {item.title === "Logout" ? (
                  <span onClick={onLogout} style={listItemTextStyles}>
                    {item.title}
                  </span>
                ) : (
                  <span
                    className={item.profileImage ? "profileImageItem" : ""}
                    style={listItemTextStyles}
                  >
                    {item.title}
                  </span>
                )}
              </ListItemText>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <UserProfileImage
        onClick={() => navigate(GeneralAdminRoutes.userProfile)}
      />
    </Drawer>
  );
};

export default GeneralAdminSidebar;

const listItemTextStyles = {
  color: "#FCFCFC",
  fontWeight: 700,
  fontSize: 14,
  fontFamily: "Avenir Book, sans-serif",
};

const listItemStyle = {
  padding: "6px 6px",
  fontFamily: "Avenir Book, sans-serif",
};

const listItemSelectedStyle = {
  padding: "12px 6px",
  background: "#1B5765",
  fontFamily: "Avenir Book, sans-serif",
};
